import {
  Autocomplete,
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  createCustomerUser,
  getCustomerUserById,
  getCustomerUserPermissions,
  updateCustomerUser,
  checkCustomerUserUsername,
  getChildCustomerByParentId,
} from "../../redux/actions/CustomerAction";
import ClearIcon from "@mui/icons-material/Clear";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import PhoneIcon from "@mui/icons-material/Phone";
import "../../CSS/User.css";
import NotificationPopup from "../../Components/NotificationPopup"; // Import NotificationPopup
import {
  CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_RESET,
  CREATE_CUSTOMER_USER_RESET,
  GET_CUSTOMER_USER_BY_ID_RESET,
  UPDATE_CUSTOMER_USER_RESET,
} from "../../Constants/Constants";
import FullPageLoader from "../../Components/FullPageLoader";

export default function User(props) {
  const { decodedToken } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const customer_login_id = JSON.parse(
    localStorage.getItem("customer_login_id")
  );

  const allProductIDs = [102, 103]; // Add all product IDs here
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [contact_number, setContact_number] = useState("");
  const [contact_number_error, setContact_number_error] = useState("");
  const [logo, setlogo] = useState("");

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");

  const [selectedProducts, setSelectedProducts] = useState({});
  const [selected_pcc, setSelected_pcc] = useState([]);
  const [PCCs, setPCCs] = useState([]);
  const [select_all_pcc, setSelect_all_pcc] = useState(false);
  const [is_default_pcc_selected, setIs_default_pcc_selected] = useState(true); // State to track if default PCC is selected

  const [notificationOpen, setNotificationOpen] = useState(false); // State for notification popup

  const GetLoggedInCustomer = useSelector((state) => state.GetLoggedInCustomer);
  const { loggedInCustomerInfo } = GetLoggedInCustomer;

  const CreateCustomerUser = useSelector((state) => state.CreateCustomerUser);
  const {
    createCustomerUserInfo,
    createCustomerUserError,
    loading: createCustomerUserLoading,
  } = CreateCustomerUser;

  const GetCustomerUserById = useSelector((state) => state.GetCustomerUserById);
  const { customerUserByIdInfo } = GetCustomerUserById;

  const GetCustomerUserPermissions = useSelector(
    (state) => state.GetCustomerUserPermissions
  );
  const { customerUserPermissionsInfo } = GetCustomerUserPermissions;

  const UpdateCustomerUser = useSelector((state) => state.UpdateCustomerUser);
  const { updateCustomerUserInfo, success, updateCustomerUserError } =
    UpdateCustomerUser;

  const CheckCustomerUserUsernameAvailability = useSelector(
    (state) => state.CheckCustomerUserUsernameAvailability
  );
  const {
    available,
    checkCustomerUserUsernameInfo,
    checkCustomerUserUsernameError,
  } = CheckCustomerUserUsernameAvailability;

  const GetChildCustomerByParentId = useSelector(
    (state) => state.GetChildCustomerByParentId
  );
  const { childCustomerInfo } = GetChildCustomerByParentId;

  const refreshPageData = () => {
    setFirst_name("");
    setLast_name("");
    setUsername("");
    setEmail("");
    setContact_number("");
    setPCCs([]);
    setSelected_pcc([]);
    setSelect_all_pcc(false);
    setSelectedProducts({});
  };

  useEffect(() => {
    refreshPageData();
    dispatch({ type: UPDATE_CUSTOMER_USER_RESET });
    dispatch({ type: GET_CUSTOMER_USER_BY_ID_RESET });
  }, []);

  useEffect(() => {
    if (customer_id) {
      dispatch(getChildCustomerByParentId(customer_id));
    }
  }, [customer_id]);

  useEffect(() => {
    dispatch({ type: CREATE_CUSTOMER_USER_RESET });

    refreshPageData();
    if (id === "new") {
      refreshPageData();
      dispatch({ type: GET_CUSTOMER_USER_BY_ID_RESET });
      dispatch({ type: UPDATE_CUSTOMER_USER_RESET });
      setIs_default_pcc_selected(true);
    } else {
      dispatch({ type: UPDATE_CUSTOMER_USER_RESET });
      dispatch(getCustomerUserById(id));
      dispatch(getCustomerUserPermissions(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (!available) {
      setUsernameError(checkCustomerUserUsernameError);
    } else {
      setUsernameError("");
    }
  }, [available, checkCustomerUserUsernameError]);

  useEffect(() => {
    if (customerUserByIdInfo && id !== "new") {
      setFirst_name(customerUserByIdInfo?.first_name?.trim() || "");
      setLast_name(customerUserByIdInfo?.last_name?.trim() || "");
      setUsername(customerUserByIdInfo?.username?.trim() || "");
      setEmail(customerUserByIdInfo?.email?.trim() || "");
      setContact_number(customerUserByIdInfo?.contact_number?.trim() || "");
      const userPCCs = customerUserByIdInfo?.pccs?.trim()?.split(" ");

      const childPCCs = childCustomerInfo?.reduce((acc, child) => {
        const childPCCArray = child?.pccs?.trim()?.split(" ") || [];
        if (userPCCs?.some((pcc) => childPCCArray.includes(pcc))) {
          acc.push(...childPCCArray);
        }
        return acc;
      }, []);
      if (childPCCs?.length > 0) {
        setPCCs((prevPCCs) => [...new Set([...prevPCCs, ...childPCCs])]);
      }
      if (
        userPCCs?.length === PCCs?.length &&
        userPCCs.every((pcc) => PCCs.includes(pcc))
      ) {
        setSelect_all_pcc(true);
        setSelected_pcc([]);
      } else {
        setSelected_pcc(userPCCs);
        setSelect_all_pcc(false);
      }
    }
  }, [customerUserByIdInfo, childCustomerInfo, id]);

  useEffect(() => {
    if (
      loggedInCustomerInfo?.pccs?.split(" ")?.every((pcc) => PCCs.includes(pcc))
    ) {
      setIs_default_pcc_selected(true);
    }
  }, [loggedInCustomerInfo, PCCs]);

  useEffect(() => {
    if (customerUserPermissionsInfo) {
      const transformedProductPermissions = customerUserPermissionsInfo?.reduce(
        (acc, item) => {
          const allPermissionFalse =
            !item.can_add &&
            !item.can_edit &&
            !item.can_delete &&
            !item.can_view;

          if (!allPermissionFalse) {
            acc[item.product_id] = {
              can_add: item.can_add,
              can_edit: item.can_edit,
              can_delete: item.can_delete,
              can_view: item.can_view,
            };
          }
          return acc;
        },
        {}
      );
      setSelectedProducts(transformedProductPermissions);
    }
  }, [customerUserPermissionsInfo]);

  useEffect(() => {
    if (loggedInCustomerInfo) {
      const pcc = loggedInCustomerInfo?.pccs?.trim()?.split(" ");
      if (is_default_pcc_selected) {
        setPCCs(pcc);
      } else {
        setPCCs([]);
      }
      setlogo(loggedInCustomerInfo?.logo);
    }
  }, [loggedInCustomerInfo]);

  useEffect(() => {
    if (createCustomerUserInfo) {
      setNotificationOpen(true);
    }
  }, [createCustomerUserInfo]);

  useEffect(() => {
    if (!notificationOpen && createCustomerUserInfo) {
      setTimeout(() => {
        navigate("/dashboard/users/manageusers");
      }, 5000);
    }
  }, [notificationOpen, createCustomerUserInfo, navigate]);

  useEffect(() => {
    if (updateCustomerUserInfo) {
      setNotificationOpen(true);
    }
  }, [updateCustomerUserInfo]);

  useEffect(() => {
    if (!notificationOpen && updateCustomerUserInfo) {
      setTimeout(() => {
        navigate("/dashboard/users/manageusers");
      }, 5000);
    }
  }, [notificationOpen, updateCustomerUserInfo, navigate]);

  const generatePassword = () => {
    const length = 12; // Desired password length
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let newPassword = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      newPassword += charset[randomIndex];
    }
    return newPassword;
  };

  const validateContactNumber = (number) => {
    // Validation: Allow numbers with or without + and country code
    // Option 1: + followed by 10-15 digits
    // Option 2: 10-15 digits
    const regex = /^(?:\+\d{1,3})?\d{10,15}$/;
    return regex.test(number);
  };

  const handleContactNumber = (e) => {
    const number = e.target.value;

    // Allow only valid characters: digits and +
    if (/^[+\d]*$/.test(number)) {
      setContact_number(number);

      if (number && !validateContactNumber(number)) {
        setContact_number_error(
          "Telephone number should be 10-15 digits, with or without a leading + and country code."
        );
      } else {
        setContact_number_error("");
      }
    }
  };

  const validateEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmail = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());

    const invalidEmails = enteredValues.filter(
      (email) => email && !validateEmail(email)
    );

    if (invalidEmails.length > 0) {
      setEmailError(`Invalid email addresses: ${invalidEmails.join(", ")}`);
    } else {
      setEmailError("");
    }
    const enteredEmail = enteredValues.join(" ");

    setEmail(enteredEmail);
  };

  const handleUsername = (event) => {
    const username = event.target.value;
    setUsername(username);
    dispatch({ type: CHECK_CUSTOMER_USER_USERNAME_AVAILABILITY_RESET });
    if (username) {
      dispatch(checkCustomerUserUsername(username));
    }
  };

  const handleProductChange = (event, productId) => {
    const isChecked = event.target.checked;

    setSelectedProducts((prevSelected) => {
      // Create a copy of the previous state
      const updatedProducts = { ...prevSelected };

      if (isChecked) {
        // Add a new product with default permissions
        updatedProducts[productId] = {
          can_add: false,
          can_edit: false,
          can_delete: false,
          can_view: true,
        };
      } else {
        // Remove the unchecked product
        delete updatedProducts[productId];
      }

      return updatedProducts;
    });
  };

  // Handle Add/Edit/Delete permission change
  const handlePermissionChange = (event, productId, permissionType) => {
    setSelectedProducts((prevSelected) => ({
      ...prevSelected,
      [productId]: {
        ...prevSelected[productId],
        [permissionType]: event.target.checked, // Toggle individual permission
      },
    }));
  };

  const handleSelectedPCCChange = (event, newValue) => {
    const [selected_value] = newValue.map((value) => value);
    if (selected_value && !selected_pcc?.includes(selected_value)) {
      setSelected_pcc((prevState) => [...prevState, selected_value]);
      if (select_all_pcc) {
        setSelect_all_pcc(false);
      }
    }
  };

  const handleSelectAllPCCs = (event) => {
    setSelect_all_pcc(event.target.checked);
    if (event.target.checked) {
      setSelected_pcc([]);
    }
  };

  const handleSelectDefaultPccs = (event) => {
    setIs_default_pcc_selected(event.target.checked);
    if (event.target.checked) {
      const defaultPCCs = loggedInCustomerInfo?.pccs?.trim()?.split(" ");
      setPCCs((prevState) => [...prevState, ...(defaultPCCs || [])]);
      setSelect_all_pcc(false);
      setSelected_pcc((prevState) =>
        prevState.filter((pcc) => !defaultPCCs?.includes(pcc))
      );
    } else {
      const defaultPCCs = loggedInCustomerInfo?.pccs?.trim()?.split(" ");
      setPCCs((prevState) =>
        prevState.filter((pcc) => !defaultPCCs?.includes(pcc))
      );
      setSelected_pcc((prevState) =>
        prevState.filter((pcc) => !defaultPCCs?.includes(pcc))
      );
    }
  };

  const handleCustomerChildPccs = (event, childId) => {
    const isChecked = event.target.checked;
    const childPCCs = childCustomerInfo?.find(
      (child) => child.customer_id === childId
    );
    const childPCCsArray = childPCCs?.pccs?.trim()?.split(" ");
    if (isChecked) {
      setPCCs((prevState) => [...prevState, ...(childPCCsArray || [])]);
      setSelect_all_pcc(false);
    } else {
      setPCCs((prevState) =>
        prevState.filter((pcc) => !childPCCsArray?.includes(pcc))
      );
      setSelected_pcc((prevState) =>
        prevState.filter((pcc) => !childPCCsArray?.includes(pcc))
      );
    }
  };

  const handleSubmit = () => {
    if (emailError || contact_number_error || usernameError) {
      setErrorAlertTitle("Invalid values in the field.");
      setErrorAlertMessage("Please enter the fields properly.");
      setErrorAlert(true);
      return;
    }

    if (
      first_name &&
      last_name &&
      username &&
      email &&
      (select_all_pcc || selected_pcc.length > 0)
    ) {
      if (Object.keys(selectedProducts).length === 0) {
        setErrorAlertTitle("Required field error");
        setErrorAlertMessage("Please select the product permission.");
        setErrorAlert(true);
        return;
      }

      const allProductsWithPermissions = allProductIDs.reduce(
        (acc, productId) => {
          acc[productId] = selectedProducts[productId] || {
            can_add: false,
            can_edit: false,
            can_delete: false,
            can_view: false,
          };
          return acc;
        },
        {}
      );

      const hasSelectedProductWithoutPermission = Object.values(
        selectedProducts
      ).some(
        (product) =>
          !product.can_add &&
          !product.can_edit &&
          !product.can_delete &&
          !product.can_view
      );

      if (hasSelectedProductWithoutPermission) {
        setErrorAlertTitle("Permission Error");
        setErrorAlertMessage(
          "Please select at least one permission for each selected product."
        );
        setErrorAlert(true);
        return;
      }

      const password = generatePassword();
      const user_data = {
        first_name,
        last_name,
        email,
        username,
        password,
        role: "customer_user",
        contact_number,
        created_by: customer_login_id,
        pccs: select_all_pcc ? PCCs.join(" ") : selected_pcc.join(" "),
        selectedProducts: allProductsWithPermissions || {},
        logo: logo,
        default_header: customerUserByIdInfo?.default_header,
        default_footer: customerUserByIdInfo?.default_footer,
        header: customerUserByIdInfo?.header?.trim() || "",
        footer: customerUserByIdInfo?.footer?.trim() || "",
      };

      if (id == "new") {
        dispatch(createCustomerUser(user_data));
      } else {
        dispatch(updateCustomerUser(id, user_data));
      }
    } else {
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage("Please enter the required fields.");
      setErrorAlert(true);
    }
  };

  return (
    <div className="wrap-mu">
      <div className="container">
        <div className="anuseadded" style={{ padding: "20px" }}>
          <h2>{id === "new" ? "Add New User" : "Edit User"}</h2>

          {/* First Name and Last Name in one row */}
          <div className="container-feld">
            <div className="txtflicol">
              <PersonOutlineIcon />
              <TextField
                className="anusercol"
                fullWidth
                label="First Name"
                required
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
              />
            </div>
            <div className="txtflicol">
              <PersonOutlineIcon />
              <TextField
                fullWidth
                className="anusercol"
                label="Last Name"
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
                required
              />
            </div>
          </div>

          {/* Email, Username and Contact number in one row */}
          <div className="container-feld">
            <div className="txtflicol">
              <PersonOutlineIcon />
              <TextField
                fullWidth
                className="anusercol"
                label="Username"
                value={username}
                onChange={(e) => {
                  const value = e.target.value.replace(/[\\/]/g, ""); // Remove / and \
                  handleUsername({ target: { value } });
                }}
                error={!!usernameError}
                helperText={usernameError}
                placeholder="eg. firstname.lastname"
                required
              />
            </div>
            <div className="txtflicol">
              <ForwardToInboxIcon />
              <TextField
                className="anusercol"
                label="Email"
                value={email}
                error={!!emailError}
                helperText={emailError}
                onChange={handleEmail}
                fullWidth
                required
              />
            </div>
            <div className="txtflicol">
              <PhoneIcon />
              <TextField
                className="anusercol"
                label="Contact Number"
                value={contact_number}
                error={!!contact_number_error}
                helperText={contact_number_error}
                onChange={handleContactNumber}
              />
            </div>
          </div>

          <div className="parent-child-feld">
            {/* Parent customer */}
            <div className="parent-customer-section">
              <Typography variant="h6">Parent Customers</Typography>
              <div className="parent-customer-checkboxes">
                <FormControlLabel
                  control={
                    <Checkbox
                      value={is_default_pcc_selected}
                      checked={!!is_default_pcc_selected}
                      onChange={handleSelectDefaultPccs}
                    />
                  }
                  label="Default"
                />
              </div>
            </div>

            {/* Child Customer */}
            <div className="child-customer-section">
              <Typography variant="h6">Child Customers</Typography>

              <div className="child-customer-checkboxes">
                {childCustomerInfo?.length > 0 &&
                  childCustomerInfo?.map((child) => {
                    return (
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={child.customer_id}
                            checked={
                              child.pccs
                                ? child.pccs
                                    ?.split(" ")
                                    .some((pcc) => PCCs.includes(pcc))
                                : false
                            }
                            onChange={(event) =>
                              handleCustomerChildPccs(event, child.customer_id)
                            }
                          />
                        }
                        label={child.customer_name}
                      />
                    );
                  })}
              </div>
            </div>
          </div>

          {/* Pcc Permission */}
          <div className="container-feld">
            <div className="autocomplete-adduser-field">
              <Autocomplete
                className="autocomplete-adduser"
                size="medium"
                multiple
                options={PCCs || []}
                getOptionLabel={(option) => option || ""}
                value={[]}
                filterOptions={(options, { inputValue }) =>
                  options.filter((option) =>
                    option?.toLowerCase()?.includes(inputValue.toLowerCase())
                  )
                }
                onChange={handleSelectedPCCChange}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select PCCs"
                      fullWidth
                    />
                  );
                }}
              />
            </div>
            {selected_pcc?.length > 0 ? (
              <div className="pcc-section">
                {selected_pcc.map((pcc, index) => {
                  const pccs = PCCs?.find((p) => p.trim() === pcc);
                  return (
                    <Button
                      key={index}
                      className="selected-pccs-button"
                      startIcon={
                        <ClearIcon className="selected-pcc-clear-icon" />
                      }
                      onClick={() => {
                        const updatedPCCs = [...selected_pcc];
                        updatedPCCs.splice(index, 1);
                        setSelected_pcc(updatedPCCs);
                      }}
                      sx={{
                        color: "#000",
                      }}
                    >
                      {pccs}
                    </Button>
                  );
                })}
              </div>
            ) : (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={select_all_pcc}
                    onChange={handleSelectAllPCCs}
                    className="green-checkbox" // Add class for custom styling
                  />
                }
                label="Select All PCCs"
              />
            )}
          </div>

          {/* Product permission */}
          <div className="user-permission">
            <Typography variant="h6">Products Permission</Typography>

            {/* Manage My Itinerary */}
            <div className="mngmyitnrycol">
              <FormControlLabel
                className="mngmyitnrycol-label"
                control={
                  <Checkbox
                    value={102}
                    checked={!!selectedProducts[102]}
                    onChange={(event) => handleProductChange(event, 102)}
                  />
                }
                label="Manage My Itinerary"
              />
              {selectedProducts[102] && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!selectedProducts[102]?.can_view}
                      onChange={(event) =>
                        handlePermissionChange(event, 102, "can_view")
                      }
                    />
                  }
                  label="View"
                />
              )}
            </div>

            {/* Ticket Report */}
            {loggedInCustomerInfo?.is_report_enabled && (
              <div className="ticketreportcol">
                <FormControlLabel
                  className="ticketreportcol-label"
                  control={
                    <Checkbox
                      value={103}
                      checked={!!selectedProducts[103]}
                      onChange={(event) => handleProductChange(event, 103)}
                    />
                  }
                  label="Ticket Report"
                />
                {selectedProducts[103] && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!selectedProducts[103]?.can_view}
                        onChange={(event) =>
                          handlePermissionChange(event, 103, "can_view")
                        }
                      />
                    }
                    label="View"
                  />
                )}
              </div>
            )}
          </div>

          <DialogActions className="svvanbtn">
            <Button
              onClick={() => navigate("/dashboard/users/manageusers")}
              color="primary"
            >
              Cancel
            </Button>
            <Button onClick={handleSubmit} color="primary">
              Save
            </Button>
          </DialogActions>
        </div>
      </div>
      {createCustomerUserInfo && (
        <NotificationPopup
          open={notificationOpen}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: CREATE_CUSTOMER_USER_RESET });
            navigate("/dashboard/users/manageusers");
          }}
          message={createCustomerUserInfo}
          severity={"success"}
        />
      )}
      {createCustomerUserError && (
        <NotificationPopup
          open={notificationOpen}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: CREATE_CUSTOMER_USER_RESET });
          }}
          message={createCustomerUserError}
          severity="error"
        />
      )}
      {errorAlert && (
        <NotificationPopup
          open={errorAlert}
          onClose={() => setErrorAlert(false)}
          message={errorAlertMessage}
          severity="error"
          title={errorAlertTitle}
        />
      )}
      {updateCustomerUserInfo && success && (
        <NotificationPopup
          open={notificationOpen}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: UPDATE_CUSTOMER_USER_RESET });
            navigate("/dashboard/users/manageusers");
          }}
          message={updateCustomerUserInfo}
          severity="success"
        />
      )}
      {updateCustomerUserError && (
        <NotificationPopup
          open={notificationOpen}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: UPDATE_CUSTOMER_USER_RESET });
          }}
          message={updateCustomerUserError}
          severity="error"
        />
      )}
      {createCustomerUserLoading && (
        <FullPageLoader open={createCustomerUserLoading} />
      )}
    </div>
  );
}
